import NoDataFound from "../../../components/common/NoDataFound";
import { useLanguage } from "../../../context/LanguageContext";

export default function StorageTab() {
  const { t } = useLanguage();
  return (
    <div className="space-y-4 border border-[#d2d2d2] rounded-[20px] p-4 bg-gradient-to-r from-[#FFFFFD] to-[#FDF8E5]">
      <NoDataFound
        title={t("Coming Soon !!")}
        message={t("Storage Working Are In-Progress")}
        mainClassName="rounded-3xl"
        subClassName="bg-transparent"
      />
    </div>
  );
}
